// eslint-disable-next-line import/prefer-default-export
export const LANDING_PAGE_TEST_IDS = {
  AUTHORS: 'header-authors',
  AUTHORS_BIO_CARDS: 'authors-bio-cards',
  AUTHORS_BIO_SECTION_TITLE: 'authors-bio-section-title',
  CONTENT: 'content',
  DATE: 'header-date',
  SCROLL_UP: 'scroll-up',
  SERIES_LIST: 'series-list',
  SERIES_TOP: 'series-top',
  SOCIAL_CONTAINER: 'social-container',
  STICKY_CTA: 'sticky-cta',
  TITLE: 'header-title',
  TOP_ARTICLES: 'top-articles',
  TOP_CONTENT: 'top-content',
};
